import { render, staticRenderFns } from "./modaltermination.vue?vue&type=template&id=8ef2c35c"
import script from "./modaltermination.vue?vue&type=script&lang=js"
export * from "./modaltermination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports